module.exports = __webpack_public_path__ + "static/24-Changes-69f972dab4cb65d5088b65a27cbd74b8.png";